// ROLE_ADMIN
export const COURSE_REQUEST = "COURSE_REQUEST";
export const COLLABORATION_REQUEST = "COLLABORATION_REQUEST";
// ROLE_TEACHER
export const CLOSE_LESSON = "CLOSE_LESSON";

// ROLE_STUDENT
export const SMALL_BALANCE = "SMALL_BALANCE";
export const NEXT_LESSON = "NEXT_LESSON";
export const CHANGE_BALANCE = "CHANGE_BALANCE";
export const CHANGE_HOMEWORK = "CHANGE_HOMEWORK";
export const CHANGE_GROUP = "CHANGE_GROUP";
export const CANCEL_LESSON = "CANCEL_LESSON";
export const RESCHEDULE_LESSON = "RESCHEDULE_LESSON";

// COMMON
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
